import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Pipe, PipeTransform } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { error, log } from 'console';
import { UtcDatePipe } from 'src/app/pipe/UtcDate.pipe';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { environment_msg } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { data } from 'jquery';
import { duration } from 'moment';

export interface attachmentElement {
  lastModifiedName: string;
  lastModifiedOn: string;
  noteDescription: string;
  taskTitle:string;
}

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css'],
  providers:[UtcDatePipe,DatePipe]
})
export class HistoryComponent implements OnInit {
  meetingId:any
  noteId : any
  displayedColumns = ['lastModifiedName', 'lastModifiedOn', 'taskTitle', 'noteDescription'];
  updateTime: any;
  meetingTzName = this.globals.vShortTimeZone;
  decisionId: any;
  taskId: any;
  taskName: any;
  decisionName: any;
  noteName: any;
  followTaskName: any;
  followTaskId: any;
  updatedName: any;
  hisEntityType:any;
  agendatype:any;
  agendaSource:any;
  showMinutes: any[] = [];
  show=false;
  display=false;
  arr=['All','Meeting','Attendee','Agenda','Note','Task','Decision']
  selectedReport:any;
  agendaSource1:any;
  AttendeeSource:any;
  NoteSource:any;
  DecisionSource:any;
  TaskSource:any;
  meetingtitle:any;
  hisselected:any;
  constructor(private spinner: NgxSpinnerService,public meetingService:MeetingService,public commonMinService:FreeFormMinutesService,public datepipe: DatePipe,private globals: Globals,private notifier:SideNavServiceService, private dialogRef: MatDialogRef<HistoryComponent>, @Inject(MAT_DIALOG_DATA) data:any) {
    if(data.type!=undefined){
       this.meetingId= data.meetingid;
       this.display=true;
       this.meetingtitle=data.meetingTitle;
       this.selectedReport="Meeting";
       this.hisselected="Meeting";
    }
    else{
      if(data.content.body != null){
        this.dataSource= data.content.body; 
        this.show=true
        this.updatedName = data.modifiedName;
      } 
    this.noteId = data.entityId;
    this.decisionId = data.entityId;
    this.taskId = data.entityId;
    this.followTaskId = data.entityId;
    this.noteName = data.modifiedName;
    this.decisionName = data.modifiedName;
    this.taskName = data.modifiedName;
    this.followTaskName = data.modifiedName;
    this.hisEntityType=data.entityType;
    }
   }
  dataSource = new MatTableDataSource<attachmentElement>();
  ngOnInit(): void {  
    if(this.hisEntityType=='AI'){
      this.displayedColumns = ['lastModifiedName', 'lastModifiedOn', 'taskTitle', 'assignedTo','dueDate','status','noteDescription'];
    }else{
      this.displayedColumns = ['lastModifiedName', 'lastModifiedOn', 'noteDescription'];
    }

    if( this.selectedReport=='Meeting'){ 
      this.meetingService.getMeetingHistory(this.meetingId).subscribe((data: any) => { 
        
        if(data.body != null){
           this.agendaSource= data.body; 
        } else{
            this.notifier.alertPhemeError(environment_msg.msg_error_no_previous_history_found);        
        }
     },error=>{
      this.notifier.alertPhemeError(error);
     }); 
    }
  }
  ngAfterViewInit() {
    this.commonMinService.activateAllCkeditor('taskTitles');
  }
  addZero(i: any) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }
  closeDialog(){
    this.dialogRef.close();
  }

  toggleMinutes(title: any) {
    if(this.showMinutes.includes(title)) {
       this.showMinutes = this.showMinutes.filter((i:any) => i != title)
    } else {
      this.showMinutes.push(title);
    }
  }

  filterCondition(event:any){
 
    this.selectedReport=event.value;
    this.hisselected=event.value;
    
    if( this.selectedReport=='Meeting'){ 
      this.spinner.show();
      this.meetingService.getMeetingHistory(this.meetingId).subscribe((data: any) => { 
        
        if(data.body != null){
           this.agendaSource= data.body; 
           this.spinner.hide();
        } else{
          this.spinner.hide();
            this.notifier.alertPhemeError(environment_msg.msg_error_no_previous_history_found);        
        }
     },error=>{
      this.spinner.hide();
      this.notifier.alertPhemeError(error);
     }); 
    }
    if( this.selectedReport=='Agenda'){ 
      this.spinner.show();
      let jsonObj={
        "meetingId":this.meetingId,
         "AgendaType":"Agenda"
      }
      this.meetingService.getAgendaHistory(jsonObj).subscribe((data: any) => { 
        if(data.body != null){
           this.agendaSource1= data.body; 
           this.spinner.hide();
        } else{
          this.spinner.hide();
            this.notifier.alertPhemeError(environment_msg.msg_error_no_previous_history_found);        
        }
     },error=>{
      this.spinner.hide();
      this.notifier.alertPhemeError(error);
     }); 
    }
    if( this.selectedReport=='Attendee'){ 
      this.spinner.show();
      var jsonObj={
        "meetingId":this.meetingId
      }
      this.meetingService.getAllAttendeeHistory(this.meetingId).subscribe((data: any) => { 
        if(data.body != null){
           this.AttendeeSource= data.body; 
           this.spinner.hide();
        } else{
          this.spinner.hide();
           this.notifier.alertPhemeError(environment_msg.msg_error_no_previous_history_found);        
        }
     },error=>{
      this.spinner.hide();
      this.notifier.alertPhemeError(error);
     }); 
    }
    if( this.selectedReport=='Note'){ 
      this.spinner.show();
      let jsonObj={
        "meetingId":this.meetingId,
        "noteType":"Note",
        "decryptKey":localStorage.getItem('decryptKey')
      }
      this.meetingService.getAllNotesHistory(jsonObj).subscribe((data: any) => { 
        if(data.body != null){
           this.NoteSource= data.body; 
           this.spinner.hide();
        } else{
          this.spinner.hide();
          this.notifier.alertPhemeError(environment_msg.msg_error_no_previous_history_found);        
        }
     },error=>{
      this.spinner.hide();
      this.notifier.alertPhemeError(error);
     }); 
    }
    if( this.selectedReport=='Task'){ 
      this.spinner.show();
      let jsonObj={
        "meetingId":this.meetingId,
        "taskType":"Task",
        "decryptKey":localStorage.getItem('decryptKey'),
        "orgCode":localStorage.getItem('orgCode')

      }
      this.meetingService.getAllTaskHistory(jsonObj).subscribe((data: any) => { 
        if(data.body != null){
           this.TaskSource= data.body; 
           this.spinner.hide();
        } else{
          this.spinner.hide();
           this.notifier.alertPhemeError(environment_msg.msg_error_no_previous_history_found);        
        }
     },error=>{
      this.spinner.hide();
      this.notifier.alertPhemeError(error);
     }); 
    }
    if( this.selectedReport=='Decision'){ 
      this.spinner.show();
      let jsonObj={
        "meetingId":this.meetingId,
        "decisiontype":"Decision",
        "decryptKey":localStorage.getItem('decryptKey')

      }
      this.meetingService.getAllDecisionHistory(jsonObj).subscribe((data: any) => { 
        if(data.body != null){
          this.DecisionSource= data.body; 
          this.spinner.hide();
        } else{
          this.spinner.hide();
          this.notifier.alertPhemeError(environment_msg.msg_error_no_previous_history_found);        
        }
     },error=>{
      this.spinner.hide();
      this.notifier.alertPhemeError(error);
     }); 
    }
    if(this.selectedReport=='All'){
      this.spinner.show();
      let jsonObj={
        "meetingId":this.meetingId,
        "meetingHisType":"All"
      }
      this.meetingService.getMeetingDetailsHistory(jsonObj).subscribe((res: any) => {
        if(res.body != null){
           this.agendaSource=res.body;
            this.spinner.hide();
        }else{
            this.spinner.hide();
            this.notifier.alertPhemeError(environment_msg.msg_error_no_previous_history_found);        
        }
      },error=>{
        this.spinner.hide();
        this.notifier.alertPhemeError(error);
       }); 
      }
  }


  }
  
  

